import React from 'react';
import { BaseInputProps, useInputHelper } from 'ui-builder';

import Layout from './Layout';

export interface BriefcaseCheckboxProps extends BaseInputProps<boolean> {

}

export function BriefcaseCheckbox(props: BriefcaseCheckboxProps) {
  const inputHelper = useInputHelper(props);

  return (
    <Layout
      {...inputHelper.getBaseInputLayoutProps()}
    />
  )
}
